export * from './IconOperatorGradient';
export { default as IconOperatorGradient } from './IconOperatorGradient';
